import { useFormContext } from 'react-hook-form';
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';

import { contractsGridColumns } from './grid-columns';
import { useFileDownload } from '../../../components/file-download';
import { UserPermissionName } from '../../../models/user-permission-name';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../api/grid-api-key-store';
import { useSaveData } from '../../../hooks/useSaveData';
import { useEffect, useState } from 'react';
import useDebounce from '../../../hooks/use-debounce';
import { State } from '@progress/kendo-data-query';
import { Contract } from '../../../models/contract';

const styling = {
  headingStyle: { fontWeight: 'bold' },
};

interface ContractsForm {
  name: string;
}
export const ContractsForm = ({ name }: ContractsForm) => {
  const { getValues } = useFormContext();
  const { error, downloadFile, isLoading } = useFileDownload();

  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Customer', 'Contract'));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredContracts, setFilteredContracts] = useState<Contract[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredContractList = (getValues(name) || []).filter((contract: any) =>
      Object.values(contract).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredContracts(filteredContractList || []);
  }, [debouncedSearchTerm, getValues(name)]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Contract',
      pageName: 'Customer',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Contract',
      pageName: 'Customer',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      //   if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      //   }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
            CONTRACTS
          </Typography>
        }
      />
      <CardContent>
        <Grid container>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <SiTrackGrid
              fileTitle='customer_contract'
              dataItemKey="contractID"
              columns={contractsGridColumns}
              //   dataItems={getValues(name)}
              onDownload={(data: any) => {
                handleDownloadFile(data);
              }}
              actionPermissions={{
                download: UserPermissionName.DOWNLOAD_CONTRACT_CUSTOMER,
                export: UserPermissionName.DOWNLOAD_GRID,
              }}
              isBusy={isLoading}
              // -----------------Grid Layout-------
              dataItems={filteredContracts || []}
              reorderable
              // handleSearch={handleInputChange}
              handleSaveLayout={handleSaveLayout}
              isSaveLayout={true}
              gridConfigFromApi={gridConfig}
              handleResetLayout={handleResetLayout}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
